export type CtaContent = {
	/** Primary popup version. Bumped only when that popup is saved. */
	version: number;
	/** Primary banner version. Bumped only when that banner is saved. */
	bannerVersion: number;
	/** Second banner version. Bumped only when that banner is saved. */
	bannerTwoVersion: number;
	bannerText: string;
	bannerLinkUrl: string | null;
	bannerScheduleStart: string | null;
	bannerScheduleEnd: string | null;
	bannerTwoText: string;
	bannerTwoLinkUrl: string | null;
	bannerTwoScheduleStart: string | null;
	bannerTwoScheduleEnd: string | null;
	popupTitle: string;
	popupBody: string;
	popupImageUrl: string | null;
	popupScheduleStart: string | null;
	popupScheduleEnd: string | null;
	popupTwoTitle: string;
	popupTwoBody: string;
	popupTwoImageUrl: string | null;
	popupTwoScheduleStart: string | null;
	popupTwoScheduleEnd: string | null;
};

export const DEFAULT_CTA_CONTENT: CtaContent = {
	version: 1,
	bannerVersion: 1,
	bannerTwoVersion: 1,
	bannerText: '',
	bannerLinkUrl: null,
	bannerScheduleStart: null,
	bannerScheduleEnd: null,
	bannerTwoText: '',
	bannerTwoLinkUrl: null,
	bannerTwoScheduleStart: null,
	bannerTwoScheduleEnd: null,
	popupTitle: '',
	popupBody: '',
	popupImageUrl: null,
	popupScheduleStart: null,
	popupScheduleEnd: null,
	popupTwoTitle: '',
	popupTwoBody: '',
	popupTwoImageUrl: null,
	popupTwoScheduleStart: null,
	popupTwoScheduleEnd: null,
};

/**
 * Identifies one announcement slot: a banner and the popup it opens when it has no link.
 * The primary popup also shows on its own at login; the secondary popup only ever opens
 * from its banner.
 */
export type CtaBannerId = 'primary' | 'secondary';

export const CTA_BANNER_IDS: CtaBannerId[] = ['primary', 'secondary'];

export type CtaBannerContent = {
	text: string;
	linkUrl: string | null;
	scheduleStart: string | null;
	scheduleEnd: string | null;
};

export const getCtaBannerContent = (
	content: CtaContent,
	bannerId: CtaBannerId,
): CtaBannerContent => (bannerId === 'primary'
	? {
		text: content.bannerText,
		linkUrl: content.bannerLinkUrl,
		scheduleStart: content.bannerScheduleStart,
		scheduleEnd: content.bannerScheduleEnd,
	}
	: {
		text: content.bannerTwoText,
		linkUrl: content.bannerTwoLinkUrl,
		scheduleStart: content.bannerTwoScheduleStart,
		scheduleEnd: content.bannerTwoScheduleEnd,
	});

export const getCtaBannerVersion = (
	content: CtaContent,
	bannerId: CtaBannerId,
): number => (bannerId === 'primary' ? content.bannerVersion : content.bannerTwoVersion);

export type CtaPopupContent = {
	title: string;
	body: string;
	imageUrl: string | null;
	scheduleStart: string | null;
	scheduleEnd: string | null;
};

export const getCtaPopupContent = (
	content: CtaContent,
	bannerId: CtaBannerId,
): CtaPopupContent => (bannerId === 'primary'
	? {
		title: content.popupTitle,
		body: content.popupBody,
		imageUrl: content.popupImageUrl,
		scheduleStart: content.popupScheduleStart,
		scheduleEnd: content.popupScheduleEnd,
	}
	: {
		title: content.popupTwoTitle,
		body: content.popupTwoBody,
		imageUrl: content.popupTwoImageUrl,
		scheduleStart: content.popupTwoScheduleStart,
		scheduleEnd: content.popupTwoScheduleEnd,
	});
